var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 352,
    height: 352,
    rx: 87,
    fill: "#F0F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 24,
    width: 48,
    height: 352,
    fill: "#D5E1E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 206,
    width: 24,
    height: 170,
    fill: "#D5E1E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 110,
    width: 48,
    height: 217,
    transform: "rotate(90 376 110)",
    fill: "#D5E1E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 242,
    width: 48,
    height: 87,
    transform: "rotate(90 111 242)",
    fill: "#D5E1E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 182,
    width: 24,
    height: 217,
    transform: "rotate(90 376 182)",
    fill: "#D5E1E8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 110,
    r: 10,
    fill: "#00B674"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 110,
    r: 17,
    stroke: "#00B674",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 110,
    r: 13,
    stroke: "#00B674",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 206,
    r: 10,
    fill: "#00B674"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 206,
    r: 17,
    stroke: "#00B674",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 206,
    r: 13,
    stroke: "#00B674",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 206H376V286C376 335.706 335.706 376 286 376H280V206Z",
    fill: "#DBFFF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111 242H24V111C24 62.9512 62.9512 24 111 24V24V242Z",
    fill: "#DBFFF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_873_570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 242,
    r: 10,
    fill: "#00B674"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 242,
    r: 17,
    stroke: "#00B674",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 242,
    r: 13,
    stroke: "#00B674",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_873_570",
    x: 89,
    y: 224,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_873_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_873_570",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapData);
export default __webpack_public_path__ + "static/media/map-data.c0e49dc08524ab118766b19b182a5a94.svg";
export { ForwardRef as ReactComponent };